import { createContext, useContext } from 'react';
import { en } from './en';
import { pl } from './pl';
const strings = { en, pl };
const I18nContext = createContext({ t: en, lang: 'en' });
export function useT() {
    return useContext(I18nContext);
}
export function getStrings(lang) {
    return strings[lang] ?? en;
}
export { I18nContext };
